import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllRmColumnsResponseModel, ColumnsDropDownResponseModel, RmColumnDropDownDto, RmColumnDto, RmColumnResponse, RmColumnsDropDownResponseModel, RmColumnsResponseModel, RmCreateColumnsResponseModel } from '@gtpl/shared-models/masters';
import { Injectable, Req } from '@nestjs/common';
import { RmColumnsRequest } from './dto/rm-column.request';
import { RmColumnsDTO } from './dto/rm-columns-dto';
import { RmColumnsAdapter } from './dto/rm-columns.adapter';
import { RmColumnsDtoActive } from './dto/rm-columns_active_inactive';
import { RmZoneRackLevelByIdDto } from './dto/rm-zoneId-request-dto';
import { RmColumnsRepository } from './rm-column.repository';
import { RmColumns } from './rm-columns-entity';



@Injectable()
export class RmColumnsService {
    constructor(private repository: RmColumnsRepository, private adapter: RmColumnsAdapter) {

    }


    async CreateColumns(details: RmColumnsDTO, isUpdate: boolean): Promise<RmCreateColumnsResponseModel> {
        try {
        if (!isUpdate) {
            const columnEntity = await this.getcolumn(details.columnsCode, details.columnsNo);
            if (columnEntity) {
                throw new RmCreateColumnsResponseModel(false,11104, 'Column  already exists');
            }
        }else{
            const columnEntity = await this.getcolumnForUpdate(details.columnsCode, details.columnsNo,details.columnsId);
            console.log(columnEntity);
            if(columnEntity){
                if(columnEntity.columnsId!= details.columnsId) {
                    throw new RmCreateColumnsResponseModel(false,11104, 'Column already exists');      
                }
            }
        }
        const convertedEntity = await this.adapter.convertDtoToEntity(details);
        const response = await this.repository.save(convertedEntity);
        if (response) {
            const data = new RmColumnDto(response.columnsCode, response.columnsNo, response.createdUser, response.isActive, response.updatedUser);
            return new RmCreateColumnsResponseModel(true, 2234, 'Column Details Created Successfully', data)
        } else {
            throw new RmCreateColumnsResponseModel(false,9999, 'Failed To Create');
        }
    }catch (error) {
        return error;
      }
    }

    async getAllColumns(): Promise<AllRmColumnsResponseModel> {
        const responseDate = await this.repository.find({order:{columnsNo:"ASC"}});

        const columnDetails: RmColumnDto[] = [];
        if (responseDate.length > 0) {
            responseDate.forEach((column) => {
                const columnData = new RmColumnDto(column.columnsCode, column.columnsNo, column.createdUser, column.isActive, column.updatedUser, column.columnsId, column.versionFlag);
                columnDetails.push(columnData);
            })
            return new AllRmColumnsResponseModel(true, 2234, 'column Details Retrived Successfully', columnDetails)
        } else {
            throw new AllRmColumnsResponseModel(false,9999, 'No Data Found');
        }
    }


    async getRecordByColumnsId(id: number): Promise<RmColumnsResponseModel> {
        const responseData = await this.repository.findOne({ where: { columnsId: id } });

        if (responseData) {
            const data = new RmColumnDto(responseData.columnsCode, responseData.columnsNo, responseData.createdUser, responseData.isActive, responseData.updatedUser);
            return new RmColumnsResponseModel(true, 7879, 'Data Retrived Successfully', data);
        } else {
            throw new RmColumnsResponseModel(false,9999, 'No Data Found');
        }
    }

    async getcolumn(columnsCode: String, columnsNo: number): Promise<RmColumns> {
        const response = await this.repository.findOne({
            where: { columnsCode: columnsCode, columnsNo: columnsNo },
        });

        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getcolumnForUpdate(columnsCode: String, columnsNo:number, id: number ): Promise<RmColumns> {
        const responseCode = await this.repository.findOne({
            where: { columnsCode: columnsCode },
        });
        const responseNo = await this.repository.findOne({
            where: {columnsNo: columnsNo },
        });
        if (responseCode || responseNo) {
            if(responseCode && responseNo){
                if(responseCode.columnsId == responseNo.columnsId){
                    return responseCode;
                }
                else if( responseCode.columnsId == id){
                    return responseNo;
                }
                else if( responseNo.columnsId == id){
                    return responseCode;
                }
                else{
                    return responseCode;
                }
            }
            else if(responseCode && !responseNo){
                return responseCode;
            }
            else if(responseNo && !responseCode){
                return responseNo;
            }
        } else {
            return null;
        }
    }
    


    async getColumnsData(columnsId: number): Promise<RmColumns> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { columnsId: columnsId },
        });

        if (response) {
            return response;
        } else {
            return null;


        }
    }
    async getColumnsById(columnsRequest: RmColumnsRequest): Promise<RmColumnsResponseModel> {
        try {
            const columnsData = await this.repository.findOne({
                where: { columnsId: columnsRequest.columnsId },
            });
            const columnDto = new RmColumnDto(columnsData.columnsCode, columnsData.columnsNo, columnsData.createdUser, columnsData.isActive, columnsData.updatedUser, columnsData.columnsId, columnsData.versionFlag)
            const response = new RmColumnsResponseModel(true, 1101, "column retrived successfully", columnDto)
            return response;
        } catch (err) {
            throw err;
        }
    }
    async activateorDeactivateColumn(columnAct: RmColumnsDtoActive): Promise<RmColumnResponse> {
        try {
            const columnExists = await this.getColumnsData(columnAct.columnsId);
            if (columnExists) {
                if (columnAct.versionFlag !== columnExists.versionFlag) {
                    throw new RmCreateColumnsResponseModel(false,10113, 'Someone updated the current columns information.Refresh and try again');
                } else {

                    const columnSatatus = await this.repository.update(
                        { columnsId: columnAct.columnsId },
                        { isActive: columnAct.isActive, updatedUser: columnAct.updatedUser });
                    const updatedRecord = await this.getRecordByColumnsId(columnAct.columnsId);
                    if (columnExists.isActive) {
                        if (columnSatatus.affected) {
                            const columnResponse: RmColumnResponse = new RmColumnResponse(true, 10115, 'Columns is de-activated successfully');
                            return columnResponse;
                        } else {
                            throw new RmCreateColumnsResponseModel(false,10111, 'Column is already deactivated');
                        }
                    } else {
                        if (columnSatatus.affected) {
                            const columncatResponse: RmColumnResponse = new RmColumnResponse(true, 10114, 'Column is activated successfully', updatedRecord.data);
                            return columncatResponse;
                        } else {
                            throw new RmCreateColumnsResponseModel(false,10112, 'column is already  activated');
                        }
                    }
                }
            } else {
                throw new RmCreateColumnsResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getColumnById(columnsId: number): Promise<RmColumns> {
        const Response = await this.repository.findOne({
        where: {columnsId: columnsId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }

    async getAllColumnDropDown(): Promise<RmColumnsDropDownResponseModel> {
      try {
          const columnsDTO: RmColumnDropDownDto[] = [];
          const columnsEntities: RmColumns[] = await this.repository.find({ select: ['columnsId', 'columnsNo','columnsCode'], where: { isActive: true }})


          if (columnsEntities && columnsEntities.length > 0) {
              columnsEntities.forEach(columnsEntity => {
                  columnsDTO.push(new RmColumnDropDownDto(columnsEntity.columnsId, columnsEntity.columnsNo,columnsEntity.columnsCode));
              });
              const response = new RmColumnsDropDownResponseModel(true, 11108, "columns retrieved successfully", columnsDTO);
              return response;
          } else {
              throw new RmCreateColumnsResponseModel(false,99998, 'Data not found');
          }
      } catch (err) {
          throw err;
      }
  }

 
  async getColumnsForZoneLevelRackId(zoneRackLevelIdReq:RmZoneRackLevelByIdDto): Promise<ColumnsDropDownResponseModel> {
      try {
          const column: RmColumnDropDownDto[] = [];
          const columnsEntities: RmColumns[] = await this.repository.find({ select: ['columnsId', 'columnsNo','columnsCode'], where: { isActive: true}})


          if (columnsEntities && columnsEntities.length > 0) {
              columnsEntities.forEach(columnsEntities => {
                  column.push(new RmColumnDropDownDto(columnsEntities.columnsId, columnsEntities.columnsNo,columnsEntities.columnsCode));
              });
              const response = new ColumnsDropDownResponseModel(true, 11108, "columns retrieved successfully",column);
              return response;
          } else {
              throw new RmCreateColumnsResponseModel(false,99998, 'Data not found');
          }
      } catch (err) {
          throw err;
      }
  }





}
